app.directive('interestTable', ['bezoeker', 'globals', '$http', '$window', '$timeout', function(bezoeker, globals, $http, $window, $timeout){
	return {
		restrict: 'EAC',
		scope: {
		  showPl: '@?',
		  showDk: '@?',
		  amounts: '=?',
		},
		templateUrl: '/templates/interest-table.html',
		link: function($scope, $element) {

			$scope.bezoeker = bezoeker;

			$scope.minimumAmountNotice = false;
			$scope.maximumAmountNotice = false;

			$scope.isLinkedTool = getIsLinkedTool();

			/* Default bedrag op mobiel*/
			$scope.amount = 25000;

			/* Default bedrag op mobiel*/
			$scope.selectedAmount = 25000;

			/* Default looptijd voor PL*/
			$scope.duration = '120';

			/* Default bedrag in procenten van het leenbedrag voor DK*/
			$scope.monthlyPayment = '0.01';

			/* Renteobject voor de complete tabel op desktop */
			$scope.interests = {};

			/* Renteobject voor mobiele weergave (1 bedrag) */
			$scope.singleAmountInterest = {};

			/* Instellen van de rentetarieven voor de complete tabel op desktop */
			function setInterests(response)
			{
				$scope.interests = response;
			}

			/* Instellen van de mobiele rentetarieven */
			function setSingleAmountInterest(response)
			{
				$scope.singleAmountInterest = response;
			}

			/* Ophalen van de rentetarieven */
			$scope.getInterests = function(data, callback)
			{
				$http.post('/ajax/getInterests/', data)
				.success(function(response){
					callback(response);
					$window.setTimeout(function() {
						$scope.rebuildSelect2();
					}, 10 );
				});
			}

			/* Ophalen van de rentetarieven voor een enkel bedrag op mobiel */
			$scope.getSingleAmountInterest = function()
			{
				$scope.minimumAmountNotice = false;
				$scope.maximumAmountNotice = false;
				if($scope.amount < globals.minimumAmount)
				{
					$scope.minimumAmountNotice = true;
					$scope.amount = globals.minimumAmount;
				}

				if($scope.amount > globals.maximumAmount)
				{
					$scope.maximumAmountNotice = true;
					$scope.amount = globals.maximumAmount;
				}

				$scope.selectedAmount = $scope.amount;
				$scope.getInterests({'showPl':$scope.showPl, 'showDk': $scope.showDk, 'amounts': [$scope.selectedAmount]}, setSingleAmountInterest);
			}

			$scope.getAmountNumber = function(value) {
				return value.replace(".","");
			};

			/* Na het opnieuw inladen van de rentetarieven moet de styling op de selectbox opnieuw geinitieerd worden. */
			$scope.rebuildSelect2 = function()
			{
				$(".plans-table select.js-select").select2({
					minimumResultsForSearch: -1,
					width: '100%',
					theme: 'pwc',
					dropdownAutoWidth: 'true'
				});
			}

			function getIsLinkedTool()
			{
				var linkedPages =  ['/','/oversluiten/doorlopend-krediet/'];
				return linkedPages.includes($window.location.pathname);
			}

			$scope.getInterests({'showPl':$scope.showPl, 'showDk': $scope.showDk, 'amounts': $scope.amounts}, setInterests);
			$scope.getInterests({'showPl':$scope.showPl, 'showDk': $scope.showDk, 'amounts': [$scope.amount]}, setSingleAmountInterest);

		}
	}
}]);